module.exports = __webpack_public_path__ + "img/21a-lrn-spt-cat-4-icon-def.b9165351.svg";